var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLeave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.167 2.66536C13.3438 2.66536 13.5134 2.7356 13.6384 2.86063C13.7634 2.98565 13.8337 3.15522 13.8337 3.33203V12.6654C13.8337 12.8422 13.7634 13.0117 13.6384 13.1368C13.5134 13.2618 13.3438 13.332 13.167 13.332H10.5003C10.1321 13.332 9.83366 13.6305 9.83366 13.9987C9.83366 14.3669 10.1321 14.6654 10.5003 14.6654H13.167C13.6974 14.6654 14.2061 14.4547 14.5812 14.0796C14.9563 13.7045 15.167 13.1958 15.167 12.6654V3.33203C15.167 2.8016 14.9563 2.29289 14.5812 1.91782C14.2061 1.54274 13.6974 1.33203 13.167 1.33203H10.5003C10.1321 1.33203 9.83366 1.63051 9.83366 1.9987C9.83366 2.36689 10.1321 2.66536 10.5003 2.66536H13.167ZM6.3051 4.19404C6.04475 3.93369 5.62264 3.93369 5.3623 4.19404L2.03659 7.51975C1.91145 7.64094 1.83366 7.81073 1.83366 7.9987C1.83366 8.09163 1.85267 8.18012 1.88702 8.26049C1.9195 8.33667 1.96681 8.40804 2.02896 8.47018L5.3623 11.8035C5.62264 12.0639 6.04475 12.0639 6.3051 11.8035C6.56545 11.5432 6.56545 11.1211 6.3051 10.8607L4.10976 8.66536H10.5003C10.8685 8.66536 11.167 8.36689 11.167 7.9987C11.167 7.63051 10.8685 7.33203 10.5003 7.33203H4.10992L6.3051 5.13685C6.56545 4.8765 6.56545 4.45439 6.3051 4.19404Z",
    fill: "#FF5F7F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLeave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-leave.5b3627a24829f9272d79ab07b1077d46.svg";